import DynamicForm from "@/components/DynamicForm";
import { cpaSchema } from "@/schemas/cpaSchema";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { useNavigate } from "react-router-dom";

const cpaFields = [
  // Personal Information
  { name: "fullName", label: "Full Name", type: "text" as const, placeholder: "John Doe" },
  { name: "email", label: "Email Address", type: "email" as const, placeholder: "john@example.com" },
  { name: "phone", label: "Phone Number", type: "tel" as const, placeholder: "+1 (555) 123-4567" },
  
  // Professional Information
  { name: "firmName", label: "Firm Name", type: "text" as const, placeholder: "ABC Accounting" },
  { name: "licenseNumber", label: "CPA License Number", type: "text" as const, placeholder: "CPA-123456" },
  { 
    name: "yearsOfExperience", 
    label: "Years of Experience", 
    type: "select" as const,
    options: [
      { value: "0-5", label: "0-5 years" },
      { value: "5-10", label: "5-10 years" },
      { value: "10-15", label: "10-15 years" },
      { value: "15+", label: "15+ years" },
    ]
  },
  
  // Location & Jurisdiction
  { name: "country", label: "Country", type: "text" as const, placeholder: "USA" },
  { name: "province", label: "Province/State", type: "text" as const, placeholder: "California" },
  { name: "city", label: "City", type: "text" as const, placeholder: "Los Angeles" },
  
  // Specialties
  { 
    name: "specialties", 
    label: "Areas of Specialization", 
    type: "textarea" as const,
    placeholder: "Describe your areas of expertise (e.g., tax planning, M&A, forensic accounting)",
    description: "Detail your specific areas of expertise"
  },
  
  // Services Offered
  { name: "taxPreparation", label: "Tax Preparation", type: "checkbox" as const, description: "I offer tax preparation services" },
  { name: "auditing", label: "Auditing", type: "checkbox" as const, description: "I offer auditing services" },
  { name: "businessConsulting", label: "Business Consulting", type: "checkbox" as const, description: "I offer business consulting services" },
  { name: "financialPlanning", label: "Financial Planning", type: "checkbox" as const, description: "I offer financial planning services" },
  
  // Additional Information
  { 
    name: "certifications", 
    label: "Additional Certifications (Optional)", 
    type: "textarea" as const,
    placeholder: "e.g., CFP, CFA, EA"
  },
  { 
    name: "languages", 
    label: "Languages Spoken (Optional)", 
    type: "text" as const,
    placeholder: "English, Spanish, French"
  },
  { 
    name: "availabilityHours", 
    label: "Availability Hours (Optional)", 
    type: "text" as const,
    placeholder: "Monday-Friday 9am-5pm"
  },
  { 
    name: "notes", 
    label: "Additional Notes (Optional)", 
    type: "textarea" as const,
    placeholder: "Any additional information you'd like to share"
  },
  
  // Terms
  { 
    name: "agreeToTerms", 
    label: "Terms and Conditions", 
    type: "checkbox" as const,
    description: "I agree to the terms and conditions and confirm that all information provided is accurate"
  },
];

export default function CPAQuestionnairePage() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="py-6">
        <DynamicForm
          schema={cpaSchema}
          fields={cpaFields}
          title="CPA Registration Questionnaire"
          description="Complete this form to register as a Certified Public Accountant partner in our network"
          collectionName="questionnaires_cpa"
          onSuccess={() => {
            setTimeout(() => navigate("/dashboard"), 2000);
          }}
        />
      </div>
    </DashboardLayout>
  );
}
